import React from "react";

interface IProps {
  history: any;
}

interface IState {
}

class NewOfferComponent extends React.Component<IProps, IState>{

  // constructor(props: IProps) {
  //     super(props);

  //     this.state = {
  //     }
  // }

  componentDidMount() {
    this.props.history.push('/offers/0')
  }

  render() {


    return (
      <div className="app-page-content">
        NewOfferComponent
            </div>
    );

  }
}

export default NewOfferComponent;
